import { render, staticRenderFns } from "./Itinerary.vue?vue&type=template&id=d20e3e84&scoped=true&"
import script from "./Itinerary.vue?vue&type=script&lang=js&"
export * from "./Itinerary.vue?vue&type=script&lang=js&"
import style0 from "./Itinerary.vue?vue&type=style&index=0&id=d20e3e84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20e3e84",
  null
  
)

export default component.exports